// Os ids são gravados em client_docs.type e usados também no site (pbbadvogados-web);
// não reaproveite valores. A ordem aqui é a ordem das abas no site.
const data = [
    { id: 1, name: "Principais Documentos" },
    { id: 4, name: "PRJ e Aditivos" },
    { id: 2, name: "Relatórios Mensais de Atividades" },
    { id: 3, name: "Atas" },
    { id: 5, name: "Relatório de Cumprimento do Plano" },
    { id: 6, name: "Relação de Credores" },
    { id: 7, name: "QGC" },
    { id: 8, name: "Editais" },
    { id: 9, name: "Autos de Arrecadação e Leilão" },
]

const RECOVERY_CATEGORIES = [1, 4, 2, 3, 5, 6, 7, 8]
const BANKRUPTCY_CATEGORIES = [1, 6, 7, 8, 9]
const EXTRAJUDICIAL_TYPE = 5

// Categorias da natureza do caso (recuperação judicial/extrajudicial ou falência e afins).
// `keepId` mantém a categoria de um documento já salvo, mesmo fora da lista do tipo.
export const getClientDocTypes = (clientType, keepId = null) => {
    if (!clientType) return [...data]

    const base = [1, EXTRAJUDICIAL_TYPE].includes(Number(clientType)) ? RECOVERY_CATEGORIES : BANKRUPTCY_CATEGORIES

    return data
        .filter((item) => base.includes(item.id) || item.id === Number(keepId))
        .map((item) =>
            item.id === 4 && Number(clientType) === EXTRAJUDICIAL_TYPE ? { ...item, name: "Plano e Aditivos" } : item
        )
}

export default [...data]
